import React from "react";
import { withStyles } from "@material-ui/core/styles";
import CommonModalV2, { modalWidth } from "./commonModal/v2";
import ModalExitAlert from "./modalExitAlert";
import Button from '@material-ui/core/Button';
import AddNoteStyle from "../../styles/addNoteStyle";
import Checkbox from '@material-ui/core/Checkbox';

const SubmitButtonRef = React.createRef();

class AddNote extends React.Component {
    state = {
        orderNoteTextError: false,
        exitModalOpen: false,
        isChangeMade: false
    }

    handleOrderNoteTextBlur = (e) => {
        let value = e.target.value.trim();
        if (value === "") {
            this.setState({ orderNoteTextError: true })
        } else if (this.state.orderNoteTextError) {
            this.setState({ orderNoteTextError: false })
        }
    }

    UNSAFE_componentWillUnmount() {
        let { ClearAddNoteData } = this.props;
        this.setState({isChangeMade: false});
        ClearAddNoteData && ClearAddNoteData();
    }

    handleOrderNoteText = (e) => {
        if (!this.state.isChangeMade) {
            this.setState({isChangeMade: true})
        }
        let { SetAddNoteValue } = this.props;
        SetAddNoteValue && SetAddNoteValue({ name: "orderNoteText", value: e.target.value })
    }

    componentDidUpdate(prevProps) {
        if (this.state.orderNoteTextError && this.props.orderNoteText && this.props.orderNoteText.trim()) {
            this.setState({ orderNoteTextError: false })
        }
        if (this.props.isNoteAdded) {
            this.onConfirmation();
        }
    }


    onAddNoteButtonClick = (e) => {
        let { orderNoteText, addPatientNote, AddNote, selectedCardData = {}, productInfo } = this.props;
        let data = {
            "OrderId": productInfo.OrderId,
            "PatientId": selectedCardData.UserId,
            "NoteText": orderNoteText,
            "AddPatientNote": addPatientNote
        };
        if (SubmitButtonRef && SubmitButtonRef.current) {
            SubmitButtonRef.current.blur && SubmitButtonRef.current.blur();
        }
        AddNote && AddNote(data);
    }

    handleCheckClick = (e) => {
        if (!this.state.isChangeMade) {
            this.setState({isChangeMade: true})
        }
        let { SetAddNoteValue, addPatientNote } = this.props;
        addPatientNote = !addPatientNote;
        SetAddNoteValue && SetAddNoteValue({ name: "addPatientNote", value: addPatientNote })
    }

    openAlertModal = () => {
        let { closeOpenAddNote } = this.props;
        if (!this.state.isChangeMade) {
            closeOpenAddNote && closeOpenAddNote();
        } else {
            this.setState({ exitModalOpen: true });
        }
    }

    closeAlertModal = () => {
        this.setState({ exitModalOpen: false });
    }

    onConfirmation = () => {
        let { closeOpenAddNote, ClearAddNoteData } = this.props;
        this.setState({ exitModalOpen: false });
        ClearAddNoteData && ClearAddNoteData();
        closeOpenAddNote && closeOpenAddNote();
    }

    render() {
        let { openAddNote, classes, orderNoteText, addPatientNote, isModalAlertOpen, SetModalAlertOpen, HandleGlobalValueChange } = this.props;
        return (
            <CommonModalV2 onGlobalValueChange={HandleGlobalValueChange} title="Add Note" open={openAddNote} toggleModal={this.openAlertModal} style={{ width: modalWidth.l }}>
                <div data-view="add-note-component-wrapper" className={classes.modalBody}>
                    <div className={classes.contentWrapperNoAlign}>
                        <div className={classes.orderNote}>ORDER NOTE:</div>
                        <div className={classes.orderNoteTextWrapper}>
                            <textarea
                                maxLength={4000}
                                spellCheck={true}
                                name={"orderNoteText"}
                                id="orderNoteText"
                                onBlur={this.handleOrderNoteTextBlur}
                                value={orderNoteText}
                                onChange={this.handleOrderNoteText}
                                className={this.state.orderNoteTextError ? classes.textAreaOrderNoteError : classes.textAreaOrderNote}
                            />

                            <div className={classes.contentWrapper}>
                                <Checkbox
                                    title=""
                                    checked={addPatientNote}
                                    id="add-patient-note-check"
                                    className={addPatientNote ? classes.checkbox : classes.disabledCheckbox}
                                    onChange={this.handleCheckClick}
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                                <div className={classes.checkboxText} onClick={this.handleCheckClick}>Also add this as a Patient Note</div>
                            </div>
                        </div>
                    </div>
                    <div className={classes.modalActionWrapper}>
                        <Button
                            disabled={
                                (!orderNoteText) || (orderNoteText && orderNoteText.trim() === "")
                            }
                            ref={SubmitButtonRef}
                            onClick={this.onAddNoteButtonClick}
                            id="addNoteSubmitBtn"
                            variant="contained" color="primary"
                            className={classes.buttonStyle}>
                            Add Note
                        </Button>
                        <Button
                            onClick={this.openAlertModal}
                            variant="contained"
                            color="primary"
                            id="addNoteCancelBtn"
                            className={classes.cancelButtonStyle}>
                            Cancel
                        </Button>
                    </div>
                </div>
                <ModalExitAlert type="confirmation" onConfirmation={this.onConfirmation} modalOpen={this.state.isChangeMade && this.state.exitModalOpen} closeModal={this.closeAlertModal} />
                <ModalExitAlert type="alert" modalOpen={isModalAlertOpen} closeModal={() => SetModalAlertOpen(false)} />
            </CommonModalV2>
        )
    }
}


export default withStyles(AddNoteStyle)(AddNote);

